import { render, staticRenderFns } from "./rwpangkat.vue?vue&type=template&id=5a5fe12b"
import script from "./rwpangkat.vue?vue&type=script&lang=js"
export * from "./rwpangkat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports